import PropTypes from 'prop-types';
import React from 'react';

import Typography from 'ravenjs/lib/Typography';

/**
 * A separator component rendered between the Breadcrumb Items.
 *
 * @constructor
 */
const BreadcrumbSeparator = React.forwardRef((props, ref) => {
    const { spacing, style, ...rest } = props;

    return (
        <Typography
            gutterBottom="0"
            gutterLeft={spacing}
            gutterRight={spacing}
            type="separator"
            {...rest}
            ref={ref}
            style={{
                userSelect: 'none',
                ...style,
            }}
        />
    );
});

BreadcrumbSeparator.propTypes = {
    /**
     * A spacing for the `left` and `right` of the separator.
     */
    spacing: PropTypes.string,
    /**
     * @ignore
     */
    style: PropTypes.object,
};

BreadcrumbSeparator.defaultProps = {
    spacing: '8px',
    style: null,
};

export default BreadcrumbSeparator;
